// angular import
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ErrorInterceptor } from 'src/app/@theme/helpers/error.interceptor';
import { BasicAuthInterceptor } from 'src/app/@theme/helpers/basic-auth.interceptor';

// project import
import { SharedModule } from './demo/shared/shared.module';
import { AdminModule } from './demo/layout/admin';
import { GuestModule } from './demo/layout/front';
import { EmptyModule } from './demo/layout/empty';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BaseModule } from './tabms/components/base/base.module';
import { NgxAngularQueryBuilderModule } from './tabms/components/global/ngx-angular-query-builder.module';
import { ToastrModule } from 'ngx-toastr';
import { OAuthModule } from 'angular-oauth2-oidc';
import { StimulsoftViewerModule } from 'stimulsoft-viewer-angular';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateLoader } from './demo/shared/custom-translate-loader';
import { AppConfigService } from './tabms/services/app-config.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorService } from './tabms/services/global/custom-paginator.service';
import { NgxIntlTelephoneInputModule } from 'ngx-intl-telephone-input';


export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
export function initializeApp(appConfigService: AppConfigService) {
  return () => {
    return appConfigService.loadConfig().then(() => {
      //environment.loadConfig(appConfigService);
    });
  };
}
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    BrowserModule,
    AdminModule,
    GuestModule,
    EmptyModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader
      }
    }),
    NgxDatatableModule,
    BaseModule,
    NgxAngularQueryBuilderModule,
		NgxIntlTelephoneInputModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right'
    }), // ToastrModule added
    OAuthModule.forRoot(),
    StimulsoftViewerModule
  ],
  exports:[
    //TranslateModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MatPaginatorIntl, useClass: CustomPaginatorService },

    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true
    },
    provideAnimations()
  ]
})
export class AppModule {}
